import { Switch, Typography } from "antd";
import React from "react";
import { SwitchOptionContainer } from "./styles";

interface SwitchComponentProps {
	title: string;
	value?: boolean;
	style?: React.CSSProperties;
	labelStyle?: React.CSSProperties;
	onChange?: (checked: boolean) => void;
	defaultChecked?: boolean;
	disabled?: boolean;
}

const SwitchOptionComponent: React.FC<SwitchComponentProps> = ({
	title,
	value,
	style,
	labelStyle,
	onChange,
	defaultChecked,
	disabled,
}) => {
	return (
		<SwitchOptionContainer>
			<Typography.Title style={labelStyle} level={5}>
				{title}
			</Typography.Title>
			<Switch
				defaultChecked={defaultChecked}
				checked={value}
				style={style}
				disabled={disabled}
				onChange={(checked: boolean) => onChange && onChange(checked)}
				checkedChildren="Açık"
				unCheckedChildren="Kapalı"
			/>
		</SwitchOptionContainer>
	);
};

export default SwitchOptionComponent;
